// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"ei-z","tooltipWrapper":"fi-z","icon":"gi-z","tooltip":"hi-z","content":"ii-z"};